import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import type { Colaborador as ColaboradorModel } from '../../../models/Colaborador';
import { environment } from 'src/environments/environment';

export enum Colaborador {
  AXA = 504,
}

export enum TipoBusqueda {
  Poblacion,
  Provincia,
  CodigoPostal,
}

@Injectable({
  providedIn: 'root'
})
export class ColaboradorService
{
  constructor(
    private http:HttpClient,
    private msal:MsalService,
  )
  {
  }

  buscar(token:string, colaborador:Colaborador, tipoBusqueda:TipoBusqueda, busqueda:string): Observable<ColaboradorModel[]> {
    const url = environment.callCenterWSBase + "/Colaborador/";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
      .set('Authorization', 'Bearer ' + token),

      params: new HttpParams({})
    };

    const query = {
      select:
      [
        "cp",
        "direccion",
        "horariolv",
        "horariomv",
        "horariosb",
        "nombre",
        "poblacion",
        "provincia",
        "taller",
        "telefono",
      ],
      parameters: [
        [{
          campo:"colaborador",
          operacion:"=",
          valor:String(colaborador),
        }],
      ],
      orden: [
        ["poblacion", "ASC"],
        ["cp", "ASC"],
      ],
    };

    const termino = busqueda.toUpperCase();
    switch (tipoBusqueda)
    {
      case TipoBusqueda.Poblacion:
        query.parameters.push
        (
          [{
            campo:"poblacion",
            operacion:"LIKE",
            valor:`%${termino}%`,
          }]
        );
        break;
      case TipoBusqueda.Provincia:
        query.parameters.push
        (
          [{
            campo:"provincia",
            operacion:"LIKE",
            valor:`%${termino}%`,
          }]
        );
        break;
      case TipoBusqueda.CodigoPostal:
        query.parameters.push
        (
          [{
            campo:"cp",
            operacion:termino.startsWith('%') || termino.endsWith('%') ? "LIKE" : "=",
            valor:termino,
          }]
        );
        break;
      default:
        const exhaustiveCheck:never = tipoBusqueda;
        throw new Error(`El programa no está preparado para la búsqueda de colaboradores de tipo: ${exhaustiveCheck}`);
    }

    return this.http.post<ColaboradorModel[]>(url, query, httpOptions);
  }
}
